import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Plus, Minus, MapPin, Package, Home, Trash2 } from 'lucide-react';
import { useCartStore } from '../store/useCartStore';
export function OrderModal() {
  const {
    isCartOpen,
    closeCart,
    items,
    updateQuantity,
    removeItem
  } = useCartStore();
  const [deliveryMethod, setDeliveryMethod] = useState('branch');
  const totalAmount = items.reduce((sum, item) => sum + parseInt(item.product.price) * item.quantity, 0);
  return <AnimatePresence data-id="element-44">
      {isCartOpen && <>
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-45">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeCart} className="fixed inset-0 bg-brand-blueDark/60 backdrop-blur-sm pointer-events-auto" data-id="element-46" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="w-full max-w-lg bg-white rounded-3xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col pointer-events-auto relative z-10" data-id="element-47">
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-48">
                <h2 className="text-2xl font-black text-brand-blue" data-id="element-49">
                  Кошик та оформлення
                </h2>
                <button onClick={closeCart} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-50">
                  <X className="w-6 h-6 text-gray-500" data-id="element-51" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto custom-scrollbar flex-1" data-id="element-52">
                {items.length === 0 ? <div className="text-center py-12" data-id="element-53">
                    <p className="text-brand-muted font-medium text-lg" data-id="element-54">
                      Ваш кошик порожній
                    </p>
                  </div> : <>
                    {/* Cart Items */}
                    <div className="space-y-4 mb-8" data-id="element-55">
                      {items.map(item => <div key={item.product.id} className="flex items-center gap-4 bg-brand-bg p-4 rounded-2xl border border-gray-100 relative group" data-id="element-56">
                          <img src={item.product.img} alt={item.product.title} className="w-16 h-16 object-cover rounded-xl border border-gray-200" data-id="element-57" />
                          <div className="flex-grow" data-id="element-58">
                            <h3 className="font-bold text-brand-blue leading-tight mb-1 pr-8" data-id="element-59">
                              {item.product.title}
                            </h3>
                            <p className="text-brand-muted font-medium text-sm mb-3" data-id="element-60">
                              {item.product.price} грн
                            </p>
                            <div className="flex items-center gap-4" data-id="element-61">
                              <div className="flex items-center border border-gray-200 rounded-lg overflow-hidden bg-white" data-id="element-62">
                                <button type="button" onClick={() => updateQuantity(item.product.id, item.quantity - 1)} className="p-2 hover:bg-gray-50 text-gray-600 transition-colors" data-id="element-63">
                                  <Minus className="w-4 h-4" data-id="element-64" />
                                </button>
                                <input type="number" value={item.quantity} onChange={e => updateQuantity(item.product.id, parseInt(e.target.value) || 1)} className="w-12 text-center font-bold text-brand-blue border-x border-gray-200 py-2 outline-none text-sm" data-id="element-65" />
                                <button type="button" onClick={() => updateQuantity(item.product.id, item.quantity + 1)} className="p-2 hover:bg-gray-50 text-gray-600 transition-colors" data-id="element-66">
                                  <Plus className="w-4 h-4" data-id="element-67" />
                                </button>
                              </div>
                            </div>
                          </div>
                          <button onClick={() => removeItem(item.product.id)} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors" data-id="element-68">
                            <Trash2 className="w-4 h-4" data-id="element-69" />
                          </button>
                        </div>)}
                    </div>

                    <form className="space-y-6" data-id="element-70">
                      {/* Recipient Details */}
                      <div data-id="element-71">
                        <h3 className="font-bold text-brand-blue mb-4 text-lg" data-id="element-72">
                          Вкажіть дані отримувача
                        </h3>
                        <div className="space-y-4" data-id="element-73">
                          <div data-id="element-74">
                            <label className="block text-sm font-bold text-gray-700 mb-1.5" data-id="element-75">
                              Прізвище, ім'я
                            </label>
                            <input type="text" placeholder="ПІБ" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20 outline-none transition-all" data-id="element-76" />
                          </div>
                          <div data-id="element-77">
                            <label className="block text-sm font-bold text-gray-700 mb-1.5" data-id="element-78">
                              Номер телефону
                            </label>
                            <input type="tel" placeholder="+380" defaultValue="+380" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20 outline-none transition-all" data-id="element-79" />
                          </div>
                        </div>
                      </div>

                      {/* Delivery */}
                      <div data-id="element-80">
                        <h3 className="font-bold text-brand-blue mb-4 text-lg" data-id="element-81">
                          Спосіб доставки (Нова Пошта)
                        </h3>
                        <div className="space-y-3" data-id="element-82">
                          <label className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${deliveryMethod === 'branch' ? 'border-brand-blue bg-brand-blue/5' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-83">
                            <input type="radio" name="delivery" value="branch" checked={deliveryMethod === 'branch'} onChange={e => setDeliveryMethod(e.target.value)} className="w-5 h-5 text-brand-blue focus:ring-brand-blue" data-id="element-84" />
                            <MapPin className={`w-5 h-5 ${deliveryMethod === 'branch' ? 'text-brand-blue' : 'text-gray-400'}`} data-id="element-85" />
                            <span className="font-bold text-gray-700" data-id="element-86">
                              У відділення
                            </span>
                          </label>

                          <label className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${deliveryMethod === 'postomat' ? 'border-brand-blue bg-brand-blue/5' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-87">
                            <input type="radio" name="delivery" value="postomat" checked={deliveryMethod === 'postomat'} onChange={e => setDeliveryMethod(e.target.value)} className="w-5 h-5 text-brand-blue focus:ring-brand-blue" data-id="element-88" />
                            <Package className={`w-5 h-5 ${deliveryMethod === 'postomat' ? 'text-brand-blue' : 'text-gray-400'}`} data-id="element-89" />
                            <span className="font-bold text-gray-700" data-id="element-90">
                              У поштомат
                            </span>
                          </label>

                          <label className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${deliveryMethod === 'courier' ? 'border-brand-blue bg-brand-blue/5' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-91">
                            <input type="radio" name="delivery" value="courier" checked={deliveryMethod === 'courier'} onChange={e => setDeliveryMethod(e.target.value)} className="w-5 h-5 text-brand-blue focus:ring-brand-blue" data-id="element-92" />
                            <Home className={`w-5 h-5 ${deliveryMethod === 'courier' ? 'text-brand-blue' : 'text-gray-400'}`} data-id="element-93" />
                            <span className="font-bold text-gray-700" data-id="element-94">
                              Адресна доставка кур'єром
                            </span>
                          </label>
                        </div>

                        {/* Dynamic Delivery Input */}
                        <div className="mt-4" data-id="element-95">
                          <label className="block text-sm font-bold text-gray-700 mb-1.5" data-id="element-96">
                            {deliveryMethod === 'branch' && 'Місто та номер відділення'}
                            {deliveryMethod === 'postomat' && 'Місто та номер поштомату'}
                            {deliveryMethod === 'courier' && 'Місто, вулиця, будинок, квартира'}
                          </label>
                          <textarea rows={2} placeholder="Введіть дані для доставки..." className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20 outline-none transition-all resize-none" data-id="element-97"></textarea>
                        </div>
                      </div>
                    </form>
                  </>}
              </div>

              <div className="p-6 border-t border-gray-100 bg-gray-50" data-id="element-98">
                {items.length > 0 && <div className="flex items-center justify-between mb-4" data-id="element-99">
                    <span className="text-lg font-bold text-gray-700" data-id="element-100">
                      Всього до сплати:
                    </span>
                    <span className="text-2xl font-black text-brand-blue" data-id="element-101">
                      {totalAmount} грн
                    </span>
                  </div>}
                <button disabled={items.length === 0} className="w-full py-4 bg-brand-yellow hover:bg-brand-yellowHover disabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed text-brand-blueDark rounded-xl font-black text-lg shadow-button transition-all transform hover:scale-[1.02] disabled:hover:scale-100" data-id="element-102">
                  Підтвердити замовлення
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}